import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers';
import { useAuth } from '@clerk/clerk-react';
import { EMAIL_OPT_OUTS_QUERY_KEY } from '@/state/queries/email-preferences/use-get-email-opt-outs';

export const useSilenceEmailOptOut = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (optOutId: string) => {
      const token = await getToken();
      return silenceEmailOptOut(optOutId, token ?? '');
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [EMAIL_OPT_OUTS_QUERY_KEY] });
    },
  });
};

const silenceEmailOptOut = async (optOutId: string, token: string) => {
  const url = `${import.meta.env.VITE_API_URL}/email-preferences/${optOutId}/silence`;
  return sendJSONRequest({ url, method: METHOD.PATCH, token });
};
